import _ from 'lodash';
import React from 'react';

import {
  SalesChannelName,
  useSalesChannelSelectFieldQuery
} from 'generated/graphql';



export interface ISalesChannel {
  id: SalesChannelName;
  displayName: string;
}

export interface IData {
  objects: ISalesChannel[];
}

export function useQuery() {
  const queryTuple = useSalesChannelSelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.salesChannels ?? [], (node): ISalesChannel => ({
        id: node.name,
        displayName: node.displayName
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
